import { render, staticRenderFns } from "./DriverShiftsTable.vue?vue&type=template&id=70efa720&"
import script from "./DriverShiftsTable.vue?vue&type=script&lang=js&"
export * from "./DriverShiftsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports